import { atom } from 'recoil';
import { defaultFormState } from '@/presentation/components/models';
export const modalUpdateSavingState = atom({
    key: 'modalUpdateSavingState',
    default: Object.assign(Object.assign({}, defaultFormState), { idCategory: null, savingName: '', savingNameError: '', savingGoal: 0, savingGoalError: '', virtualAccount: null, dirtyFields: { savingName: false, savingGoal: false } })
});
